<template>
	<div>
		<breadcrumb :list="breadcrumbList"></breadcrumb>
		<el-card class="main">
			<el-form ref="searchEmp" :model="searchEmp" class="searchEmp">
				<el-row>
					<el-col :xs="24" :sm="12" :md="5" :lg="5">
						<el-form-item label-width="80px">
							<div slot="label">打卡类型</div>
							<el-select v-model="searchEmp.gz_lx" placeholder="请选择" style="width:100%">
								<el-option v-for="item in dklxList" :key="item.code" :label="item.title" :value="item.code">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="5" :lg="5">
						<el-form-item label-width="70px">
							<div slot="label">姓名</div>
							<el-input size="medium" v-model="searchEmp.cyry_xm" clearable>
							</el-input>
						</el-form-item>
					</el-col>

					<el-col :xs="24" :sm="12" :md="7" :lg="7">
						<el-form-item label-width="75px">
							<div slot="label">时间</div>
							<el-date-picker v-model="searchEmp.time" type="datetimerange" align="right" start-placeholder="开始日期"
								end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="timestamp"
								style="width:100%">
							</el-date-picker>
						</el-form-item>
					</el-col>

					<el-col :xs="24" :sm="12" :md="12" :lg="7" style="float:right">
						<el-row style="text-align:end;width:100%">
							<el-button type="info" @click="clean_btn" class="clean_btn">重置</el-button>

							<el-button type="primary" @click="search_btn" class="search_btn">查询</el-button>
							<el-button type="primary" @click="set_range" class="set_range">设置打卡范围</el-button>
						</el-row>
					</el-col>
				</el-row>
			</el-form>


			<Total :total="total"></Total>
			<el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#F1F2F7', color: '#606266' }">
				<el-table-column prop="dyid" label="日志编号" min-width="150" align="center">
				</el-table-column>
				<el-table-column prop="cyry_xm" label="姓名" min-width="100" align="center">
				</el-table-column>
				<el-table-column prop="cyry_bm" label="人员编号" min-width="170" align="center">
				</el-table-column>
				<el-table-column prop="gz_hwxx" label="岗位信息" min-width="100" align="center">
				</el-table-column>
				<el-table-column prop="gzdd" label="工作地点" min-width="100" align="center">
				</el-table-column>
				<el-table-column prop="gz_kssj" label="打卡时间" min-width="160" align="center" :formatter="sjFormatter">
				</el-table-column>
				<el-table-column prop="gz_lx" label="打卡类型" min-width="100" align="center" :formatter="dklxFormatter">
				</el-table-column>
			</el-table>

			<!-- 分页 -->

			<div class="page">
				<el-pagination v-if="tableData.length != 0" class="fy" layout="prev, pager, next" :total="total"
					:page-size="pageData.page_size" :current-page="pageData.page_no" @current-change="current_change" background>
				</el-pagination>
			</div>
		</el-card>
	</div>
</template>

<script>
// import { mapState } from 'vuex'
import Total from '@/components/total/index.vue'
import { getEmpLogList } from '@/api/day_work.js'
import { filtersInfo, lists } from '@/utils/dictionary.js'
import { formatDate } from '@/utils'
// // AES - 128 - ECB解密
// import AES from '@/utils/AES.js'

export default {
	name: "EmployeesIndex",
	data() {
		return {
			breadcrumbList: [ // 面包屑所需数据
				{ name: '人员日志', path: 'per_log' }
			],
			searchEmp: {},
			dklxList: [ //打卡类型
			],
			tableData: [],
			total: 0, // 表格数据总数
			pageData: {
				// count: null, //总数
				page_no: 1,  //现在
				page_size: 10, //每页条数
				// page:25 //总页数
			},
			loading: true
		};
	},
	/*  computed: {
			...mapState({
				isClock: (state) => state.user.isClock
			})
		},*/
	watch: {
		'$store.state.user.isClock'(newVal, oldVal) {
			//对数据执行操作
			console.log(newVal, oldVal)
			if (newVal) {
				this.info()
			}
		}
	},
	created() {
		this.info()
	},
	methods: {
		async info() {
			this.dklxList = lists['DKLX']
			const res = await getEmpLogList({ ...this.pageData, ...this.searchEmp })
			this.total = res.total_result
			this.pageData.page_no = res.page_no
			this.pageData.page_size = res.page_size
			/* 	// 解密
				res.items.forEach(item => {
					item.gzdd = AES.decrypt(item.gzdd)
				}) */
			this.tableData = res.items

			this.$store.dispatch('user/changeClockState', false)

		},
		search_btn() { // 查询
			// 当前页强制转为1
			this.pageData.page_no = 1
			const time = this.searchEmp.time
			this.searchEmp.start_time = time ? time[0] / 1000 : ''
			this.searchEmp.end_time = time ? time[1] / 1000 : ''
			this.info()
		},
		clean_btn() { // 重置
			this.searchEmp = {}
		},
		clock_in() { // 打卡
			console.log("打卡");
		},
		current_change(val) { //分页功能
			this.pageData.page_no = val
			this.info()
		},
		dklxFormatter(row, column, cellValue) { //格式化人员类别
			if (cellValue != 0 && !cellValue) return ''
			return filtersInfo(this.dklxList, cellValue)
		},
		sjFormatter(row, column, cellValue) { //格式化时间
			if (cellValue != 0 && !cellValue) return ''
			return formatDate(cellValue)
		},
		set_range(){
			this.$router.push('/per_log/set_range')
		}
	},
	components: { Total }
}
</script>

<style lang="less" scoped>
.main {
	margin: 20px;
	padding: 20px 20px;

	.searchEmp {

		/deep/ .el-input--medium,
		/deep/ .el-form-item__label {
			font-size: 16px;
		}
	}

	/deep/ .el-form-item {
		margin-right: 20px;
	}



	/deep/ .el-select {
		width: 100%;
	}

	/deep/ thead {
		background-color: #F1F2F7;
		// z-index: 999;
	}

	/deep/ .el-table__row {
		.el-button {
			width: 60px;
			height: 32px;
			// opacity: 0.1;
			border-radius: 16px;
		}
	}


	// .search_btn {
	// 	width: 80px;
	// 	background: #6345D5;
	// 	border: 1px solid #6345D5;
	// 	border-radius: 6px;
	// 	font-size: 16px;
	// 	font-family: Source Han Sans SC;
	// 	font-weight: 500;
	// 	color: #FFFFFF;
	// }

	// .clean_btn {
	// 	width: 80px;
	// 	background: #FFFFFF;
	// 	border: 1px solid #6345D5;
	// 	border-radius: 6px;
	// 	font-size: 16px;
	// 	font-family: Source Han Sans SC;
	// 	font-weight: 500;
	// 	color: #6345D5;
	// }

	// .clock_in {
	// 	width: 80px;
	// 	background: green;
	// 	border: 1px solid #6345D5;
	// 	border-radius: 6px;
	// 	font-size: 16px;
	// 	font-family: Source Han Sans SC;
	// 	font-weight: 500;
	// 	color: #fff;
	// }
}
</style>
